import { render, staticRenderFns } from "./addShopCommunity.vue?vue&type=template&id=c57b51e8"
import script from "./addShopCommunity.vue?vue&type=script&lang=js"
export * from "./addShopCommunity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports